module.exports = __webpack_public_path__ + "media/icons/mobile-menu-icon-dark-gray-bfa95f3d.png";